import React, { useContext, useState, useRef, useEffect, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { Box, Button, Text, FormControl, Input, FlatList, Select } from 'native-base'

import { Context as LanguageContext } from '../../context/LanguageContext'
import { Context as AuthContext } from '../../context/AuthContext'
import { Context as MembersContext } from '../../context/MembersContext'

import {I18n} from 'i18n-js';
import AppTranslations from '../../../src/i18n/i18n'

import { applyMembersFilters, validateMemberIcNumber, validateMemberIcSeries } from '../../api/members';
import { hasOwnProperties } from '../../api/object';
import { capitalizeWord } from '../../api/string';

const i18n = new I18n({
    ...AppTranslations
  });
  
i18n.enableFallback = true;

const MemberICFilter = () => {

    const authCtx = useContext(AuthContext)
    const membersCtx = useContext(MembersContext)
    
    const languageCtx = useContext(LanguageContext)
    i18n.locale = languageCtx.state;

    const [errors, setErrors] = useState({})

    const memberICSeriesInputRef = useRef()
    const memberICNumberInputRef = useRef()
    
    return <Box>

        {/* <Text>Errors: {JSON.stringify(errors)} </Text> */}
        
        <FormControl isInvalid={'icSeries' in errors}>
            <FormControl.Label _text={{bold: true}}>
                {i18n.t('icSeries')}
            </FormControl.Label>
            <Input placeholder={i18n.t('icSeries')} 
                value={membersCtx?.state?.filters?.icSeries}
                ref={memberICSeriesInputRef}
                onSubmitEditing={() => {

                    if ( !hasOwnProperties(validateMemberIcSeries(membersCtx?.state?.filters?.icSeries)) && 
                        !hasOwnProperties(validateMemberIcNumber(membersCtx?.state?.filters.icNumber))
                    ) {

                        applyMembersFilters(membersCtx)
                        memberICSeriesInputRef.current.focus()
                    } else {

                        memberICNumberInputRef.current.focus()
                    }
                }}
                onChangeText={value => {

                    const crtError = validateMemberIcSeries(capitalizeWord(value))

                    if (hasOwnProperties(crtError)) {

                        setErrors({
                            ...errors,
                            ...crtError
                        })
                    } else {

                        delete errors.icSeries
                        setErrors(errors)
                    }


                    membersCtx.setFilters({
                        ...membersCtx.state.filters, 
                        icSeries: capitalizeWord(value)
                    })    
                    
                }}
            />
            
            {
                'icSeries' in errors ? 
                <FormControl.ErrorMessage _text={{fontSize: 'xs'}}>
                    { i18n.t(errors.icSeries) }
                </FormControl.ErrorMessage> : null
                // <FormControl.HelperText _text={{fontSize: 'xs'}}>
                //     {i18n.t('msgNameIsMandatory')}
                // </FormControl.HelperText>
            }
        </FormControl>

        <FormControl isInvalid={'icNumber' in errors}>
            <FormControl.Label _text={{bold: true}}>
                {i18n.t('icNumber')}
            </FormControl.Label>
            <Input placeholder={i18n.t('icNumber')} 
                value={membersCtx?.state?.filters?.icNumber}                
                ref={memberICNumberInputRef}
                onSubmitEditing={() => {

                    if ( !hasOwnProperties(validateMemberIcSeries(membersCtx?.state?.filters?.icSeries)) && 
                        !hasOwnProperties(validateMemberIcNumber(membersCtx?.state?.filters?.icNumber))
                    ) {

                        applyMembersFilters(membersCtx)
                    }

                    memberICNumberInputRef.current.focus()
                }}
                onChangeText={value => {

                    const crtError = validateMemberIcNumber(value)

                    if (hasOwnProperties(crtError)) {

                        setErrors({
                            ...errors,
                            ...crtError
                        })
                    } else {

                        delete errors.icNumber
                        setErrors(errors)
                    }

                    membersCtx.setFilters({
                        ...membersCtx.state.filters, 
                        icNumber: value
                    })    
                    
                }}
            />
            
            {
                'icNumber' in errors ? 
                <FormControl.ErrorMessage _text={{fontSize: 'xs'}}>
                    { i18n.t(errors.icNumber) }
                </FormControl.ErrorMessage> : null
                // <FormControl.HelperText _text={{fontSize: 'xs'}}>
                //     {i18n.t('msgNameIsMandatory')}
                // </FormControl.HelperText>
            }
        </FormControl>

    </Box>
};

const styles = StyleSheet.create({ 
    container: {
        borderWidth: 1
    },
    backgroundImage: {
        flex: 1
    }
})

export default MemberICFilter;